// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 63 ? "component---src-components-tgr-site-js" : chunkId) + "-" + {"63":"3859ec32cdee822998b3","223":"7fa9e0b7fc1c8992cc39","843":"e40e39fcf83edf0f277d"}[chunkId] + ".js";
};